module.exports = ".trends-ul li {\n  display: inline;\n  padding: 1em;\n}\n\ninput[type=checkbox]{\n  margin: 10px 10px 10px;\n}\n\n:host /deep/ .dropdown-menu>.active>a,\n.dropdown-menu>.active>a:focus,\n.dropdown-menu>.active>a:hover {\n  background-color: #F6F6F6;\n  color: #323232;\n}\n\n:host /deep/ .dropdown-menu>a {\n  color: #323232;\n}\n\n:host /deep/ .dropdown-menu>li>a{\n  padding: 0.75em 1.25em  /* 12px 20px * 0.0625;*/\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/t4-bed-size-categories/bed-size-categories.component.css
// module id = ./src/app/t4-bed-size-categories/bed-size-categories.component.css
// module chunks = bed-size-categories.module